import register from 'ShopUi/app/registry';import { importWithFallback } from 'PyzShopUi/scripts/utils/importWithFallback';

export default register('add-to-cart-form', () =>
    importWithFallback(
        /* webpackMode: "lazy" */
        () => import('./add-to-cart-form')
        ),
);
